function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14v14H0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#9068BE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "10.555",
  cy: "5.742",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.813 1.094h-.711V.547a.547.547 0 10-1.094 0v.547H7.52V.547a.547.547 0 10-1.094 0v.547H3.965V.547a.547.547 0 10-1.094 0v.547h-.683A2.19 2.19 0 000 3.28v8.531A2.19 2.19 0 002.188 14H6.37a.547.547 0 100-1.094H2.187c-.603 0-1.093-.49-1.093-1.094v-8.53c0-.604.49-1.095 1.093-1.095h.684v.547a.547.547 0 101.094 0v-.546h2.46v.546a.547.547 0 101.095 0v-.546h2.488v.546a.547.547 0 101.094 0v-.546h.71c.604 0 1.094.49 1.094 1.093v3.117a.547.547 0 101.094 0V3.281a2.19 2.19 0 00-2.188-2.187z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.691 7.383a3.312 3.312 0 00-3.308 3.308A3.312 3.312 0 0010.69 14 3.312 3.312 0 0014 10.691a3.312 3.312 0 00-3.309-3.308zm0 5.523a2.217 2.217 0 01-2.214-2.215c0-1.22.993-2.214 2.214-2.214 1.222 0 2.215.993 2.215 2.214a2.217 2.217 0 01-2.215 2.215z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.484 10.145h-.246V9.57a.547.547 0 10-1.093 0v1.121c0 .302.244.547.546.547h.793a.547.547 0 100-1.093z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8.176",
  cy: "5.742",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5.797",
  cy: "8.121",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "3.418",
  cy: "5.742",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "3.418",
  cy: "8.121",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "3.418",
  cy: "10.5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5.797",
  cy: "10.5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5.797",
  cy: "5.742",
  r: "1"
})))));